// extracted by mini-css-extract-plugin
export default {"editor":"SinkEditor_editor__2idTI","label":"SinkEditor_label__ZAHkO","name":"SinkEditor_name__5OFN5","designer":"SinkEditor_designer__9MgWQ","tab":"SinkEditor_tab__NN0-T"};